import { useCallback, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { UserAccessRequestType } from 'entities/Users'
import { useMembersViewContext } from 'pages/settings/pages/members/pages/membersView/context/membersViewContext'
import { MembersTable } from 'pages/settings/pages/members/pages/membersView/ui/MembersTable/MembersTable'
import { getAccessRequestColumns } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/ui/getAccessRequestColumns'
import { getAccessRequestActions } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/ui/getAccessRequestActions'
import { requestsAccessActionConfig } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/lib/requestsAccessActionConfig'

export const PermissionsUpdateTab = observer(() => {
  const entities = useEntitiesContext()
  const { fetchCounts, requestsMembersStore } = useMembersViewContext()
  const { permissionsUpdateStore } = requestsMembersStore

  const {
    init,
    tableStore,
    loading,
    loadData,
    search,
    setSearch,
    dispose,
    itemsRows,
    scrollToTopTrigger,
  } = permissionsUpdateStore

  const onSuccess = useCallback(() => {
    loadData()
    fetchCounts()
  }, [])

  useEffect(() => {
    init()
    return dispose
  }, [])

  const columns = useMemo(
    () => getAccessRequestColumns(UserAccessRequestType.PermissionsUpdate),
    []
  )

  const rows = itemsRows.map((item) => {
    item.setActionsProps({
      ...requestsAccessActionConfig,
      actions: getAccessRequestActions(item, { entities, onSuccess }),
    })

    return item
  })

  return (
    <MembersTable
      setSearch={setSearch}
      search={search}
      emptyStateProps={{
        text: 'No permissions update requests',
        noIcon: true,
      }}
      tableProps={{
        ariaLabel: 'PermissionsUpdateTable',
        rows,
        columns,
        loading,
        store: tableStore,
        pinnedColumnIds: ['fullName'],
        scrollToTOpTrigger: scrollToTopTrigger,
      }}
    />
  )
})
